/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useRef, useState } from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import { DocumentContext } from "~context/DocumentContext";
import AppearOnScroll from "~components/AppearOnScroll";
import Button from "~components/Button";
import CollectionShelf from "~components/CollectionShelf";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import Parallaxer from "~components/Parallaxer";
import SEO from "~components/SEO";
import Video from "~components/Video";
import ArrowBottomLeft from "~components/svg/ArrowBottomLeft";
import ArrowBottomRight from "~components/svg/ArrowBottomRight";
import FacebookIcon from "~components/svg/FacebookIcon";
import InstagramIcon from "~components/svg/InstagramIcon";
import SquiggleSmall from "~components/svg/SquiggleSmall";
import { sortArrayByPriority } from "~utils/helpers";

// import monogram from "~assets/images/monogram.png";

const IndexPage = ({ data, location }) => {
  const { device } = useContext(DocumentContext);

  const submitRef = useRef();

  const [email, setEmail] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  //

  const cms = data.sanityIndex;

  const collections = [];

  let bestSellers;

  if (data?.allSanityCollection?.edges?.[0]) {
    data.allSanityCollection.edges.forEach(({ node }) => {
      if (node.title.toLowerCase() === `best sellers`) {
        bestSellers = node;
      }

      collections.push(node);
    });
  }

  sortArrayByPriority(collections);

  const [hoveredCollection, setHoveredCollection] = useState(
    collections?.[0]?.image?.asset?.fluid
  );

  //

  const submitProxy = () => {
    if (!submitRef?.current) {
      return;
    }

    submitRef.current.click();
  };

  const onSubmit = e => {
    e.preventDefault();

    if (
      typeof window !== `undefined` &&
      window.location.href.includes(`localhost:8000`)
    ) {
      setSubmitting(true);

      setTimeout(() => {
        setSubmitting(false);
        setSubmitted(true);
      }, 3000);

      return false;
    }

    if (
      submitting ||
      submitted ||
      !process.env.GATSBY_NETLIFY_FUNCTIONS ||
      !process.env.GATSBY_MAILCHIMP_API_KEY ||
      !process.env.GATSBY_MAILCHIMP_LIST_ID
    ) {
      return false;
    }

    setSubmitting(true);

    const mailchimpData = {
      firstName,
      lastName,
      email,
      list_id: process.env.GATSBY_MAILCHIMP_LIST_ID
    };

    fetch(`${process.env.GATSBY_NETLIFY_FUNCTIONS}/mailchimp`, {
      body: JSON.stringify(mailchimpData),
      method: `POST`
    })
      .then(() => {
        setSubmitting(false);
        setSubmitted(true);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });

    return false;
  };

  //

  let buttonText = `Submit`;

  if (submitting) {
    buttonText = `Submitting...`;
  } else if (submitted) {
    buttonText = `Thanks!`;
  }

  //

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout className="index-page w-full relative">
        <section className="index-page__banner w-full sixteen-by-nine relative flex items-center justify-center overflow-hidden bg-off-white">
          <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center">
            {(cms?.bannerVideo?.asset?.url && (
              <>
                {(device === `desktop` && (
                  <Video
                    className="animation-appear-down animation-delay-2 w-full h-full relative block object-cover"
                    src={cms.bannerVideo.asset.url}
                    poster={cms?.bannerVideoPoster?.asset?.fluid?.src}
                  />
                )) || (
                  <Video
                    className="animation-appear-down animation-delay-2 w-full h-full relative block object-cover"
                    src={cms.bannerVideo.asset.url}
                    poster={cms?.bannerVideoPosterXS?.asset?.fluid?.src}
                  />
                )}
              </>
            )) || (
              <figure className="animation-appear-down-slow animation-delay-5 w-full h-full relative block">
                {cms?.bannerVideoPoster?.asset?.fluid?.src && (
                  <img
                    className="w-full h-full relative block object-cover"
                    src={cms?.bannerVideoPoster?.asset?.fluid?.src}
                    alt="Home"
                  />
                )}
              </figure>
            )}
          </div>

          {cms?.bannerLogo?.asset && (
            <Parallaxer atTop className="w-1/2 md:w-1/5" reverse severe>
              <Link
                to={`${cms?.bannerLogoClickTarget || `/`}`}
                className="animation-appear-down-slow animation-delay-5 w-full relative block"
              >
                {(cms?.bannerLogo?.asset?.fluid && (
                  <Img
                    className="w-full relative block"
                    fluid={cms.bannerLogo.asset.fluid}
                    alt="Banner Icon"
                  />
                )) || (
                  <>
                    {cms?.bannerLogo?.asset?.url && (
                      <img
                        className="w-full relative block"
                        src={cms.bannerLogo.asset.url}
                        alt="Banner Icon"
                      />
                    )}
                  </>
                )}
              </Link>
            </Parallaxer>
          )}

          <div className="absolute bottom-0 right-0 z-10 hidden md:flex items-end justify-end mr-v3 mb-v2">
            <a
              href="https://www.instagram.com/joeyscandizzosalon"
              rel="noopener noreferrer"
              target="_blank"
              className="h-v2 pt-v05"
              style={{ marginRight: `1.5vw` }}
            >
              <InstagramIcon className="h-full" />
            </a>

            <a
              href="https://www.facebook.com/JoeyScandizzoSalon/"
              rel="noopener noreferrer"
              target="_blank"
              className="h-v2 pt-v05"
            >
              <FacebookIcon className="h-full" />
            </a>
          </div>

          {cms?.bannerBookingNumber && (
            <div className="absolute bottom-0 left-0 right-0 md:right-auto flex md:block items-center justify-center z-10">
              <h3 className="index-page__banner__button relative bg-orange text-cream f4">
                <a href={`tel:${cms.bannerBookingNumber}`}>
                  Call to make a booking
                </a>
              </h3>
            </div>
          )}
        </section>

        <section className="w-full relative md:flex">
          <article className="w-full md:w-1/2 relative bg-brown text-cream">
            {(device === `desktop` && (
              <div className="square">
                <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex flex-col justify-between pt-v3 pr-v2 pb-v2 pl-v2">
                  <div className="w-full relative">
                    <h1 className="mb-v1 f1">Shop the collections</h1>

                    <ul>
                      {collections.map(collection => {
                        return (
                          <li key={collection.handle} className="relative">
                            <Link
                              to={`/collections/${collection.handle}`}
                              className="pt-v05 h1 inline-block hover-underline cursor-pointer"
                              onMouseOver={() =>
                                setHoveredCollection(
                                  collection.image.asset.fluid
                                )
                              }
                            >
                              {collection.title}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <div>
                    <Link to="/collections">
                      <h3 className="hover-underline mb-v2 f4">SEE MORE</h3>
                    </Link>
                  </div>
                </div>
              </div>
            )) || (
              <>
                <header className="w-full relative grid pt-8 pb-4">
                  <h3 className="grid-end-10 grid-start-2 f2 text-center">
                    Shop the collections
                  </h3>

                  <h4 className="grid-end-10 grid-start-2 mt-4 b2 text-center">
                    We’ve combed the world for the best haircare products,
                    curated just for you.
                  </h4>
                </header>

                <ul className="grid pb-8">
                  {collections.map(collection => {
                    return (
                      <li
                        key={collection.handle}
                        className="grid-end-6 relative"
                      >
                        <Link to={`/collections/${collection.handle}`}>
                          <div
                            className="relative"
                            style={{ paddingBottom: `125%` }}
                          >
                            {collection?.image?.asset?.fluid && (
                              <figure className="w-full h-full absolute top-0 right-0 bottom-0 left-0">
                                <Img
                                  className="w-full h-full relative block object-cover"
                                  fluid={collection.image.asset.fluid}
                                  alt="Collection product feature"
                                />
                              </figure>
                            )}
                          </div>

                          <div className="w-full h-8 relative flex items-center justify-center mt-2 mb-4 bg-orange text-bone">
                            <span className="caption">{collection.title}</span>
                          </div>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </article>

          <article className="w-full md:w-1/2 relative hidden md:block">
            <div className="square">
              <figure className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center">
                {hoveredCollection && (
                  <Img
                    className="w-full h-full relative block object-cover"
                    fluid={hoveredCollection}
                    alt="Collection product feature"
                  />
                )}
              </figure>
            </div>
          </article>
        </section>

        {bestSellers && <CollectionShelf collection={bestSellers} noBorder />}

        <AppearOnScroll className="index-page__social w-full relative md:flex">
          <div className="md:w-1/3 md:h-full relative">
            {cms?.lowerImageLeft?.asset?.fluid && (
              <Img
                className="w-full h-full relative block object-cover"
                fluid={cms.lowerImageLeft.asset.fluid}
                alt="Woman flicking hair"
              />
            )}
          </div>

          <div className="md:w-1/3 md:h-full relative">
            {cms?.lowerImageMiddle?.asset?.fluid && (
              <Img
                className="w-full h-full relative hidden md:block object-cover"
                fluid={cms.lowerImageMiddle.asset.fluid}
                alt="Woman flicking hair"
              />
            )}
          </div>

          <article
            className={`md:w-1/3 md:h-full relative flex flex-col items-start justify-between ${
              device === `desktop`
                ? `pt-v3 pr-v3 pb-v3 pl-v3`
                : `pt-10 pr-4 pb-12 pl-4`
            } bg-orange text-bone`}
          >
            <form
              className={`form ${
                submitting || submitted ? `opacity-50 pointer-events-none` : ``
              } transition-opacity w-full relative`}
              onSubmit={onSubmit}
            >
              <input
                ref={submitRef}
                className="w-0 h-0 hidden opacity-0 pointer-events-none"
                type="submit"
              />

              <h3 className="f3 uppercase">
                {cms?.lowerFormHeading || `Join the Scandizzo Family`}
              </h3>

              {cms?.lowerFormSubheading && (
                <p
                  className={`${
                    device === `desktop` ? `mt-v05 mb-v2` : `mt-4 mb-6`
                  } b2`}
                >
                  {cms.lowerFormSubheading}
                </p>
              )}

              <input
                className={`w-full relative block ${
                  device === `desktop` ? `mt-v1` : `h-12 mb-3`
                } bg-transparent text-bone b1`}
                onChange={e => setFirstName(e.currentTarget.value)}
                placeholder="First name"
                required
                type="text"
              />

              <SquiggleSmall color="bone" />

              <input
                className={`w-full relative block ${
                  device === `desktop` ? `mt-v1` : `h-12 mb-3`
                } bg-transparent text-bone b1`}
                onChange={e => setLastName(e.currentTarget.value)}
                placeholder="Last name"
                required
                type="text"
              />

              <SquiggleSmall color="bone" />

              <input
                className={`w-full relative block ${
                  device === `desktop` ? `mt-v1` : `h-12 mb-3`
                } bg-transparent text-bone b1`}
                onChange={e => setEmail(e.currentTarget.value)}
                placeholder="Email"
                required
                type="email"
              />

              <SquiggleSmall color="bone" />

              <Button
                className={`${
                  device === `desktop` ? `mt-v4 pl-v3 pr-v3` : `w-full mt-6`
                }`}
                color="scarlet"
                onClick={submitProxy}
              >
                <span className="block f-button">{buttonText}</span>
              </Button>
            </form>

            <div className="h-full relative flex flex-col justify-between pt-v6">
              <div>
                <h3
                  className={`${
                    device === `desktop` ? `mb-v05` : `mt-12 mb-5`
                  } f3 uppercase`}
                >
                  Make a booking
                </h3>

                <div className="w-full relative flex items-center">
                  <ArrowBottomRight className="w-v2" color="bone" />

                  <div>
                    <p
                      className={`${
                        device === `desktop` ? `ml-v2` : ``
                      } f4 uppercase`}
                    >
                      <a href="tel:+61398277503">9827 7503</a>
                    </p>
                    <p
                      className={`${
                        device === `desktop` ? `ml-v2` : ``
                      } f4 uppercase`}
                    >
                      <a href="mailto:info@joeyscandizzo.com">
                        info@joeyscandizzo.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <h3 className="mt-12 md:mt-0 f3 uppercase">
                <span>Follow the fun on{` `}</span>
                <a
                  href="https://www.instagram.com/joeyscandizzosalon"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="underline"
                >
                  Instagram
                </a>

                <ArrowBottomLeft className="w-v2 mt-v05" color="bone" />
              </h3>
            </div>
          </article>
        </AppearOnScroll>
      </Layout>

      <Footer />
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query IndexPage {
    sanityIndex {
      title
      seoDescription
      seoKeywords

      bannerVideo {
        asset {
          url
        }
      }

      bannerVideoPoster {
        asset {
          fluid {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }

      bannerVideoPosterXS {
        asset {
          fluid {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }

      bannerLogoClickTarget
      bannerBookingNumber
      bannerLogo {
        asset {
          fluid {
            ...GatsbySanityImageFluid_noBase64
          }

          url
        }
      }

      lowerImageLeft {
        asset {
          fluid {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }

      lowerImageMiddle {
        asset {
          fluid {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }

      lowerFormHeading
      lowerFormSubheading
    }

    allSanityCollection {
      edges {
        node {
          title
          handle
          priority
          description
          image {
            asset {
              fluid {
                ...GatsbySanityImageFluid_noBase64
              }
            }
            altText
          }
        }
      }
    }
  }
`;
